import React from "react";
import { CertificateTemplate } from "./certificateTypes";

type CertificateTemplateSelectorProps = {
  templates: CertificateTemplate[];
  activeId: string;
  defaultId: string;
  onSelect: (id: string) => void;
  onRename: (name: string) => void;
  onSaveAsNew: () => void;
  onDuplicate: () => void;
  onReset: () => void;
  onSetDefault: () => void;
};

function CertificateTemplateSelector({
  templates,
  activeId,
  defaultId,
  onSelect,
  onRename,
  onSaveAsNew,
  onDuplicate,
  onReset,
  onSetDefault,
}: CertificateTemplateSelectorProps) {
  const active = templates.find((item) => item.id === activeId);

  return (
    <div className="certificate-section">
      <h3>Template</h3>
      <div className="certificate-field">
        <label htmlFor="certificate-template">Saved templates</label>
        <select
          id="certificate-template"
          value={activeId}
          onChange={(event) => onSelect(event.target.value)}
        >
          {templates.map((template) => (
            <option key={template.id} value={template.id}>
              {template.name}
              {template.id === defaultId ? " (Default)" : ""}
            </option>
          ))}
        </select>
      </div>
      <div className="certificate-field">
        <label htmlFor="certificate-template-name">Template name</label>
        <input
          id="certificate-template-name"
          value={active?.name ?? ""}
          onChange={(event) => onRename(event.target.value)}
        />
      </div>
      <div className="certificate-template-actions">
        <button type="button" className="certificate-btn certificate-btn-primary" onClick={onSaveAsNew}>
          Save as new
        </button>
        <button type="button" className="certificate-btn" onClick={onDuplicate}>
          Duplicate
        </button>
        <button type="button" className="certificate-btn" onClick={onReset}>
          Reset to default
        </button>
        <button type="button" className="certificate-btn" onClick={onSetDefault}>
          Set as default
        </button>
      </div>
    </div>
  );
}

export default CertificateTemplateSelector;
